// extracted by mini-css-extract-plugin
module.exports = {"checkboxes__wrapper":"Checkboxes_checkboxes__wrapper__1gWoM","checkboxes__wrapperVertical":"Checkboxes_checkboxes__wrapperVertical__50zYA"};